/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Code_MappingsInputs */

const en_nav_code_mappings = /** @type {(inputs: Nav_Code_MappingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External codes`)
};

/**
* | output |
* | --- |
* | "External codes" |
*
* @param {Nav_Code_MappingsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_code_mappings = /** @type {((inputs?: Nav_Code_MappingsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Code_MappingsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_code_mappings(inputs)
});